export const themes = {
    dark: {
        background: {
            color: '#141414',
        },
    },
    custom: {
        background: {
            image: 'asset/width-660/picture/20236c9846df57385d8535907c4b0cb2.png',
        },
        space: {
            paddingTop: 32,
            paddingBottom: 32,
        },
        vars: {
            '--feature-bg-default': '#efeeed',
            '--feature-color-default': '#521bdb',
            '--feature-color-default-r': '#fff',
            '--feature-color-primary': '#521bdb',
            '--feature-color-primary-r': '#fff',
            '--feature-color-weak': '#405077',
            '--feature-color-weakest': '#405077',
            '--feature-color-view-more': '#405077',
            '--feature-color-split': '#521bdb',

            '--feature-card-bg': 'hsla(30,6%,93%,.4)',
            '--feature-card-color': 'rgba(64,80,119,.65)',
            '--feature-collapse-more-color': '#405077',

            '--feature-review-card-bg': '#521bdb',
            '--feature-review-card-color': '#fff',
            '--feature-review-star-color': '#fff',
        }
    }
}